import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';
import { GlobalStyles } from './styles/global-styles';
import { Route, Routes } from 'react-router-dom';
import Dashboard from './modules/Dashboard/Dashboard';
import GerenciarClientes from './modules/GerenciarClientes/GerenciarClientes';
import GerenciarContas from './modules/GerenciarContas/GerenciarContas';
import Logs from './modules/Logs/Logs';
import Transferencias from './modules/Transferencias/Transferencias';
import TransacoesBoletos from './modules/TransacoesBoletos/TransacoesBoletos';
import Login from './modules/Login/Login';
import Pagamentos from './modules/Pagamentos/Pagamentos';
import PerfisUsuarios from './modules/PerfisUsuarios/PerfisUsuarios';
import Emprestimo from './modules/Emprestimo/Emprestimo';
import Sidebar from './components/Sidebar';
import SweetAlert from './components/SweetAlert/SweetAlert';
import RequireAuth from './RequireAuth';
import NotFound from './modules/NotFound/NotFound';
import ServicosDigitais from './modules/ServicosDigitais/ServicosDigitais';
import Reports from './modules/Reports/Reports';
import Wallet from './modules/Wallet/Wallet';

const App = () => (
  <ThemeProvider theme={theme}>
    <GlobalStyles />
    <Sidebar />
    <SweetAlert />
    <Routes>
      <Route
        path="*"
        element={
          <RequireAuth>
            <NotFound />
          </RequireAuth>
        }
      />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      />
      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      />
      <Route
        path="/pagamentos"
        element={
          <RequireAuth>
            <Pagamentos />
          </RequireAuth>
        }
      />
      <Route
        path="/gerenciar-clientes"
        element={
          <RequireAuth>
            <GerenciarClientes />
          </RequireAuth>
        }
      />
      <Route
        path="/gerenciar-contas"
        element={
          <RequireAuth>
            <GerenciarContas />
          </RequireAuth>
        }
      />
      <Route
        path="/perfis"
        element={
          <RequireAuth>
            <PerfisUsuarios />
          </RequireAuth>
        }
      />
      <Route path="/login" element={<Login />} />
      <Route
        path="/boletos"
        element={
          <RequireAuth>
            <TransacoesBoletos />
          </RequireAuth>
        }
      />
      <Route
        path="/logs"
        element={
          <RequireAuth>
            <Logs />
          </RequireAuth>
        }
      />
      <Route
        path="/emprestimo"
        element={
          <RequireAuth>
            <Emprestimo />
          </RequireAuth>
        }
      />
      <Route
        path="/transferencias"
        element={
          <RequireAuth>
            <Transferencias />
          </RequireAuth>
        }
      />
      <Route
        path="/recarga"
        element={
          <RequireAuth>
            <ServicosDigitais />
          </RequireAuth>
        }
      />
      <Route
        path="/relatorios"
        element={
          <RequireAuth>
            <Reports />
          </RequireAuth>
        }
      />
      <Route
        path="/relatorio-comissao"
        element={
          <RequireAuth>
            <Wallet />
          </RequireAuth>
        }
      />
    </Routes>
  </ThemeProvider>
);

export default App;
